<button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
  [mat-dialog-close]="true" id="closeBtn">
  <img src="../../../assets/icons/x-button.svg">
</button>
<div class="confir_sec">
  <div class="row">
    <div class="col-sm-12" *ngIf="data.userType.access != 'linkAccount'">
      <img height="60px" width="60px" style="float: left;" [defaultImage]="defaultImage"
        [lazyLoad]="data.userType.imgPath">
    </div>
    <div class="col-sm-12 successTitle">
      <h2>{{data.userType.titleOne}}</h2>
    </div>
  </div>
  <mat-dialog-actions style=" gap: 13px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'teamdelete'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="DeletBtnClick()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 13px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'deleteCardDetails'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="deleteCardConfirm()"
      [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>


  <mat-dialog-actions style="  margin: 0; padding: 0;" *ngIf="data.userType.access == 'logout'" class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="logoutClick()"
      [mat-dialog-close]="true">Yes</button>&nbsp;&nbsp;&nbsp;
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 13px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'EventDelete'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="EvenctDeletOk(data.userType.id)"
      [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>



  <mat-dialog-actions style=" gap: 10px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'declineOrder'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button (click)="declineOrderConfirm(data.userType.id)"
      [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 10px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'unLinkAccount'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button (click)="deleteStripeAccount()"
      [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style="margin: 0; padding: 0;" *ngIf="data.userType.access == 'linkAccount'"
    class="action_sec">
      <button class="btn_no" mat-raised-button (click)="connectToStripe()"
      [mat-dialog-close]="true" style="width: 100%;">Yes</button>
  </mat-dialog-actions>

</div>